import 'rxjs/add/operator/map';
import { GlobalVariables } from "../variables/global";
import { HttpService } from './http-service';
import { Injectable } from '@angular/core';
import { LoginModel } from './../models/loginModel';
import { RequestOptions, Headers } from '@angular/http';
import { UserModel } from './../models/userModel';
import { environment } from './../environments/environment';

interface logoServiceInterface {
  file: any,
  user: string,
  isAdmin?: boolean
}

@Injectable()
export class DeveloperProvider {

  constructor(public http: HttpService) { }

  login(user: LoginModel) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    let body = {
      username: user.username,
      password: user.password
    }

    return this.http.post(
      environment.BASE_URL + 'developers/user/login',
      body,
      options)
      .map(res => res.json());
  }

  logout() {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    let body = {
      username: GlobalVariables.username
    }

    return this.http.post(
      environment.BASE_URL + 'developers/user/logout',
      body,
      options)
      .map(res => res.json());
  }

  // TODO: Delete this method after the testing is finished
  goToOnlinePortal(amountRequested?: String) {
    return this.getUser(GlobalVariables.username).flatMap(userData => {
      let headers = new Headers();
      headers.append('Content-Type', 'application/X-www-form-urlencoded');
      headers.append('Authorization', 'Basic ' + GlobalVariables.authToken);
      let options = new RequestOptions({ headers: headers, withCredentials: true });
      let data = 'grant_type=client_credentials&client_id=' + userData.client_id + '&client_secret=' + userData.client_secret;

      return this.http.post(
        environment.BASE_URL + 'oauth/token',
        data,
        options)
        .map(res => {
          return res.json().access_token;
        })
        .flatMap((accessToken: string) => {
          let headers = new Headers();
          headers.append('Content-Type', 'application/X-www-form-urlencoded');
          headers.append('Authorization', 'Bearer ' + accessToken);
          let options = new RequestOptions({ headers: headers, withCredentials: true });
          let data = 'is_sandbox=1'
          data += amountRequested !== '' ? '&amount_requested=' + amountRequested : '';
          return this.http.post(
            environment.BASE_URL + 'online/client-id/' + userData.client_id + '/systems/init',
            data,
            options)
            .map(res => res.json());
        })
    })
  }

  permissionRequest(user: UserModel) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    return this.http.post(
      environment.BASE_URL + 'developers/user',
      user,
      options)
      .map(res => res.json());
  }

  getUsers(usersPages: number) {
    return this.http.get(
      environment.BASE_URL
      + 'developers/admin/user?'
      + 'usersPages=' + usersPages, { withCredentials: true })
      .map((res => res.json()))
  }

  filterUsers(filterParams) {

    let queryPath = '';

    Object.keys(filterParams).forEach(function (key, index) {
      if (filterParams[key] !== '') {
        queryPath += (queryPath.includes('?')) ? '&' : '?';
        queryPath = queryPath + key + '=' + filterParams[key];
      }
    });

    return this.http.get(
      environment.BASE_URL + 'developers/admin/user' + queryPath, { withCredentials: true })
      .map((res => res.json()))
  }

  getUserByAdmin(username: string) {
    return this.http.get(environment.BASE_URL + 'developers/admin/user/' + username, { withCredentials: true })
      .map((res => res.json()))
  }

  getUser(username: string) {
    return this.http.get(environment.BASE_URL + 'developers/user/' + username, { withCredentials: true })
      .map((res => res.json()))
  }

  getUserPlans(username: string) {
    return this.http.get(environment.BASE_URL + 'developers/user/' + username + '/plans', { withCredentials: true })
      .map((res => res.json()))
  }

  updateUser(user: UserModel) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    return this.http.put(
      environment.BASE_URL + 'developers/admin/user/' + user.username,
      user,
      options)
      .map(res => res.json());
  }

  updateNoAdminUser(userInfo: any, user: string) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    return this.http.put(
      environment.BASE_URL + 'developers/user/' + user + '/update',
      userInfo,
      options)
      .map(res => res.json());
  }

  forgotPassword(username: string, email: string, password: string) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    let body = {
      email: email,
      password: password
    }
    return this.http.post(
      environment.BASE_URL + 'developers/user/' + username + '/forgot',
      body,
      options)
      .map(res => res.json());
  }

  resetPassword(token: string, username: string, password: string) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    let body = {
      password: password
    }
    return this.http.post(
      environment.BASE_URL + 'developers/user/' + username + '/password?token=' + token,
      body,
      options)
      .map(res => res.json());
  }

  uploadLogo(args: logoServiceInterface) {
    let body = { logo: args.file };
    let options = new RequestOptions({ withCredentials: true });
    let role = (args.isAdmin) ? 'admin' : 'user';
    return this.http.post(
      environment.BASE_URL + 'developers/' + role + '/' + args.user + '/uploadLogo',
      body,
      options)
      .map(res => res.json());
  }

  updateLogo(args: logoServiceInterface) {
    let body = { logo: args.file };
    let options = new RequestOptions({ withCredentials: true });
    let role = (args.isAdmin) ? 'admin' : 'user';

    return this.http.put(
      environment.BASE_URL + 'developers/' + role + '/' + args.user + '/uploadLogo',
      body,
      options)
      .map(res => res.json());
  }

  requestProdCredentials(user: string) {
    let options = new RequestOptions({ withCredentials: true });
    return this.http.post(
      environment.BASE_URL + 'developers/user/' + user + '/request-credentials',
      {},
      options)
      .map(res => res.json());
  }

  sendProdCredentials(user: string) {
    let options = new RequestOptions({ withCredentials: true });
    return this.http.post(
      environment.BASE_URL + 'developers/admin/user/' + user + '/send-credentials',
      {},
      options)
      .map(res => res.json());
  }

  getPasswordPolicies() {
    let options = new RequestOptions({ withCredentials: true });
    return this.http.get(
      environment.BASE_URL + 'developers/passwordpolicies',
      options)
      .map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/providers/developers.ts